import React, { useEffect, useState } from "react";
import "./Map.css";
import { Box, Button, useMediaQuery } from "@mui/material";
import Start from "../../../../assets/new/qlt5_default.jpg";
import Ani1 from "../../../../assets/new/qlt5_vendor-01.gif";
import Close1 from "../../../../assets/vendor-02_close-up.png";
import Still1 from "../../../../assets/new/qlt5_vendor-01_still.jpg";
import Ani2 from "../../../../assets/new/qlt5_vendor-02.gif";
import Close2 from "../../../../assets/vendor-03_close-up.png";
import Still2 from "../../../../assets/new/qlt5_vendor-02_still.jpg";
import Ani3 from "../../../../assets/new/qlt5_vendor-03-p1.gif";
import Ani4 from "../../../../assets/new/qlt5_vendor-03-p2.gif";
import Close3 from "../../../../assets/new/qlt5_vendor-03_close-up.png";
import End from "../end/End";
import Chat from "../chat/Chat";
import {
  getSavingVariables,
  getSavingVariablesFil,
} from "../../../../utils/firestoreQuery";
import Play1 from "../../../../assets/mareng-risa_play.png";
import Done1 from "../../../../assets/mareng-risa_done.png";
import Play2 from "../../../../assets/madam-burda_play.png";
import Done2 from "../../../../assets/madam-burda_done.png";
import Play3 from "../../../../assets/sir-manny_play.png";
import Done3 from "../../../../assets/sir-manny_done.png";
import { West } from "@mui/icons-material";
import { useSelector, useDispatch } from "react-redux";
import { setPageState } from "../features/ChatSlice";
import Toast from "../../../../assets/toast-message-02.png";
import FinishButton from "../../../../assets/new/finish-button.png";

const useProgressiveImage = (src) => {
  const [sourceLoaded, setSourceLoaded] = useState(null);

  useEffect(() => {
    const img = new Image();
    img.src = src;
    img.onload = () => setSourceLoaded(src);
  }, [src]);

  return sourceLoaded;
};

function Map() {
  const md = useMediaQuery("(min-width:900px)", { noSsr: true });

  const pageState = useSelector((state) => state.chat.pageState);
  const lang = useSelector((state) => state.chat.language);
  const [state, setState] = useState(0);
  const [img, setImg] = useState(Start);
  const [objData, setObjData] = useState();
  const loaded = useProgressiveImage(img);
  const dispatch = useDispatch();
  const [toasted, setToasted] = useState(false);
  const [toasted2, setToasted2] = useState(false);
  const [replay, setReplay] = useState(0);
  const [tracker, setTracker] = useState(0);

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (lang === "ENG") {
          const documentSnapshot = await getSavingVariables().get();
          if (documentSnapshot.exists) {
            const data = documentSnapshot.data();

            setObjData(data);
          } else {
            console.log("Document does not exist");
          }
        } else if (lang === "FIL") {
          const documentSnapshot = await getSavingVariablesFil().get();
          if (documentSnapshot.exists) {
            const data = documentSnapshot.data();

            setObjData(data);
          } else {
            console.log("Document does not exist");
          }
        }
      } catch (error) {
        console.error("Error fetching document:", error);
      }
    };

    fetchData();
  }, [lang]);

  useEffect(() => {
    // Start the bouncing animation on page load
    const playButton = document.querySelector(".play-1st");
    const playButton2 = document.querySelector(".play-2nd");
    const playButton3 = document.querySelector(".play-3rd");
    if (playButton) {
      playButton.classList.add("bounce");
      playButton2.classList.add("bounce");
      playButton3.classList.add("bounce");
    }
  }, [img]);

  const handleClick = (select) => {
    const playButton = document.querySelector(".play-1st");
    const playButton2 = document.querySelector(".play-2nd");
    const playButton3 = document.querySelector(".play-3rd");

    if (select === "btn1" && state < 1) {
      setState(state + 1);
      setToasted(false);
    } else if (select === "btn2" && state === 2) {
      setState(state + 1);
      setToasted2(false);
    } else if (select === "btn3" && state === 4) {
      setState(state + 1);
    } else if (select === "convo") {
      if (replay === 0) {
        setState(state + 1);
        setTracker(0);
      } else {
        setReplay(0);
        console.log("State:", state);
        setTracker(1);
      }
    }

    if (select === "btn2" && state < 1) {
      setToasted(true);
    } else if (select === "btn3" && state === 2) {
      setToasted2(true);
    }

    if (playButton) {
      playButton.classList.remove("bounce");
      void playButton.offsetWidth;
      playButton.classList.add("bounce");

      playButton2.classList.remove("bounce");
      void playButton2.offsetWidth;
      playButton2.classList.add("bounce");

      playButton3.classList.remove("bounce");
      void playButton3.offsetWidth;
      playButton3.classList.add("bounce");
    }
  };

  useEffect(() => {
    if (state === 0) {
      setImg(Start);
    } else if (state === 1) {
      setImg(Ani1);
      setTimeout(() => {
        setImg(Close1);
      }, 3000);
    } else if (state === 2) {
      setImg(Still1);
      setTracker(0);
    } else if (state === 3) {
      setImg(Ani2);
      setTimeout(() => {
        setImg(Close2);
      }, 4000);
    } else if (state === 4) {
      setImg(Still2);
      setTracker(0);
    } else if (state === 5) {
      setImg(Ani3);
      setTimeout(() => {
        setImg(Ani4);
        setTimeout(() => {
          setImg(Close3);
        }, 2000);
      }, 2300);
    } else if (state >= 6) {
      dispatch(setPageState("finish"));
    }
  }, [state, tracker]);

  const handleReplay = (btn) => {
    if (btn === "btn1") {
      setReplay(1);
      setImg(Close1);
    } else if (btn === "btn2") {
      setReplay(2);
      setImg(Close2);
    }
  };

  return (
    <>
      {state === 6 && pageState === "finish" ? (
        <End />
      ) : (
        <Box
          //   className="map-container"
          sx={
            {
              // backgroundImage: `url(${loaded || img})`,
              // backgroundColor: "white",
            }
          }
        >
          {/* <Box className="image-container"> */}
          <div
            style={{
              position: "relative",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
            }}
          >
            <img
              src={loaded || img}
              style={{
                display: "block",
                width: "100%",
                height: md ? "100vh" : "auto",
                objectFit: "fill",
              }}
              alt="image"
            />

            {img !== Close1 && img !== Close2 && img !== Close3 ? (
              <>
                {state > 1 ? (
                  <>
                    <img
                      src={Done1}
                      alt="button"
                      className={
                        md ? "play-1st bounce" : "play-1st-mobile bounce"
                      }
                      onClick={() => handleReplay("btn1")}
                    />
                  </>
                ) : (
                  <>
                    {toasted && (
                      <img
                        src={Toast}
                        alt="toast"
                        className={
                          md
                            ? "play-1st-toast bounce"
                            : "play-1st-toast-mobile bounce"
                        }
                      />
                    )}
                    <img
                      src={Play1}
                      alt="button"
                      className={
                        md ? "play-1st bounce" : "play-1st-mobile bounce"
                      }
                      onClick={() => handleClick("btn1")}
                    />
                  </>
                )}
              </>
            ) : (
              <>
                <Box
                  style={{
                    position: md ? "absolute" : "inherit",
                    width: "100%",
                    height: "100%",
                    paddingTop: "1rem",
                    backgroundColor: md ? "transparent" : "#3f4e56",
                  }}
                >
                  <Box
                    className="convo-box"
                    sx={{
                      width: md ? "80%" : "inherit",
                    }}
                  >
                    {(state === 1 || replay === 1) && (
                      <>
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            backgroundColor: "#FFFFFF40",
                            height: "70%",
                            padding: "1.5rem",
                            borderRadius: "1rem",
                          }}
                        >
                          <Chat
                            pageLang={lang}
                            objData={objData.step1}
                            mainContainer={{
                              height: md ? "inherit" : "400px",
                              flexGrow: "1",
                            }}
                          />
                        </Box>
                        <Button
                          className="temp-next"
                          onClick={() => handleClick("convo")}
                          startIcon={<West />}
                        >
                          {lang === "ENG" ? "Back to Map" : "Bumalik sa Mapa"}
                        </Button>
                      </>
                    )}
                    {(state === 3 || replay === 2) && (
                      <>
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            backgroundColor: "#FFFFFF40",
                            height: "70%",
                            padding: "1.5rem",
                            borderRadius: "1rem",
                          }}
                        >
                          <Chat
                            pageLang={lang}
                            objData={objData.step2}
                            mainContainer={{
                              height: md ? "inherit" : "400px",
                              flexGrow: "1",
                            }}
                          />
                        </Box>
                        <Button
                          className="temp-next"
                          onClick={() => handleClick("convo")}
                          startIcon={<West />}
                        >
                          {lang === "ENG" ? "Back to Map" : "Bumalik sa Mapa"}
                        </Button>
                      </>
                    )}
                    {state === 5 && (
                      <>
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            backgroundColor: "#FFFFFF40",
                            height: "70%",
                            padding: "1.5rem",
                            borderRadius: "1rem",
                          }}
                        >
                          <Chat
                            pageLang={lang}
                            objData={objData.step3}
                            mainContainer={{
                              height: md ? "inherit" : "400px",
                              flexGrow: "1",
                            }}
                          />
                        </Box>
                        <Box
                          className="finish-container"
                          onClick={() => handleClick("convo")}
                        >
                          <img
                            src={FinishButton}
                            alt="Button"
                            className="finish-img"
                          />
                        </Box>
                      </>
                    )}
                  </Box>
                </Box>
              </>
            )}
            {img !== Close1 && img !== Close2 && img !== Close3 && (
              <>
                {state > 3 ? (
                  <>
                    <img
                      src={Done2}
                      alt="button"
                      className={
                        md ? "play-2nd bounce" : "play-2nd-mobile bounce"
                      }
                      onClick={() => handleReplay("btn2")}
                    />
                  </>
                ) : (
                  <>
                    {toasted2 && (
                      <img
                        src={Toast}
                        alt="toast"
                        className={
                          md
                            ? "play-2nd-toast bounce"
                            : "play-2nd-toast-mobile bounce"
                        }
                      />
                    )}
                    <img
                      src={Play2}
                      alt="button"
                      className={
                        md ? "play-2nd bounce" : "play-2nd-mobile bounce"
                      }
                      onClick={() => handleClick("btn2")}
                    />
                  </>
                )}
              </>
            )}
            {img !== Close1 && img !== Close2 && img !== Close3 && (
              <>
                {state > 5 ? (
                  <>
                    <img
                      src={Done3}
                      alt="button"
                      className={
                        md ? "play-3rd bounce" : "play-3rd-mobile bounce"
                      }
                    />
                  </>
                ) : (
                  <>
                    <img
                      src={Play3}
                      alt="button"
                      className={
                        md ? "play-3rd bounce" : "play-3rd-mobile bounce"
                      }
                      onClick={() => handleClick("btn3")}
                    />
                  </>
                )}
              </>
            )}
          </div>
        </Box>
        // </Box>
      )}
    </>
  );
}

export default Map;
